// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29euz","questions":"styles_questions__3N6rr","footer":"styles_footer__1n7Wa"};